module.exports = __webpack_public_path__ + "img/code.0003796c.png";